import { useEffect } from 'react';
import { useQueryClient } from 'react-query';

export const useClearUnreadCount = (): void => {
  const queryClient = useQueryClient();

  useEffect(() => {
    return () => {
      setTimeout(() => {
        queryClient.invalidateQueries(['unread-posts-count']);
      }, 2000);
    };
  }, [queryClient]);
};
